import { render, staticRenderFns } from "./termsConditions.vue?vue&type=template&id=25d4dc29&scoped=true&"
import script from "./termsConditions.vue?vue&type=script&lang=js&"
export * from "./termsConditions.vue?vue&type=script&lang=js&"
import style0 from "./termsConditions.vue?vue&type=style&index=0&id=25d4dc29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d4dc29",
  null
  
)

export default component.exports